import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  MapContainer,
  TileLayer,
  Marker,
  Polyline,
  Popup,
  useMap,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { FaMapMarkerAlt } from "react-icons/fa";
import L from "leaflet";
import "../css/OrdersScreen.css";

import Sidebar from "./Sidebar";
import Header from "./Header";
import PageTitle from "./PageTitleCompoent";
import OrderCard from "./OrderCard";
import OrderImg1 from "../assets/order_img_1.png";
import OrderImg2 from "../assets/order_img_2.png";
import OrderImg3 from "../assets/order_img_3.png";

const OrdersScreen = () => {
  const navigate = useNavigate();
  const [selectedOrder, setSelectedOrder] = useState(null);
  const handleBack = () => navigate(-1);
  const handleCardClick = (order) => setSelectedOrder(order);
  const handleCloseModal = () => setSelectedOrder(null);

const orders = [
  {
    id: "ORD-10001",
    productImage: OrderImg1,
    name: "Pedigree",
    quantity: 1,
    weight: "1.5kg",
    price: "500",
    paymentMethod: "Card",
    customer: "Livia",
    orderTime: "26-04-25, 11AM",
    deliveryTime: "28-04-25, 10AM",
    shopName: "The Pet Shop",
    status: "In Progress",
    pickupLat: 37.7749,
    pickupLng: -122.4194,
    dropLat: 37.784,
    dropLng: -122.409,
  },
  {
    id: "ORD-10002",
    productImage: OrderImg2,
    name: "Whiskas",
    quantity: 2,
    weight: "2kg",
    price: "700",
    paymentMethod: "UPI",
    customer: "Arjun",
    orderTime: "25-04-25, 9AM",
    deliveryTime: "27-04-25, 1PM",
    shopName: "Paws & Claws",
    status: "On Delivery",
    pickupLat: 37.7841,
    pickupLng: -122.4145,
    dropLat: 37.792,
    dropLng: -122.402,
  },
  {
    id: "ORD-10003",
    productImage: OrderImg3,
    name: "Drools",
    quantity: 3,
    weight: "3kg",
    price: "900",
    paymentMethod: "Cash",
    customer: "Meera",
    orderTime: "24-04-25, 5PM",
    deliveryTime: "26-04-25, 10AM",
    shopName: "Pet Planet",
    status: "Delivered",
    pickupLat: 37.762,
    pickupLng: -122.432,
    dropLat: 37.772,
    dropLng: -122.421,
  },
  {
    id: "ORD-10004",
    productImage: OrderImg1,
    name: "Royal Canin",
    quantity: 1,
    weight: "1kg",
    price: "600",
    paymentMethod: "Card",
    customer: "Ravi",
    orderTime: "23-04-25, 8AM",
    deliveryTime: "25-04-25, 4PM",
    shopName: "The Pet Corner",
    status: "In Progress",
    pickupLat: 37.789,
    pickupLng: -122.401,
    dropLat: 37.797,
    dropLng: -122.389,
  },
  {
    id: "ORD-10005",
    productImage: OrderImg2,
    name: "Purepet",
    quantity: 2,
    weight: "5kg",
    price: "1200",
    paymentMethod: "Netbanking",
    customer: "Sana",
    orderTime: "22-04-25, 6PM",
    deliveryTime: "24-04-25, 10AM",
    shopName: "Pet Needs",
    status: "Booked",
    pickupLat: 37.756,
    pickupLng: -122.425,
    dropLat: 37.764,
    dropLng: -122.411,
  },
  {
    id: "ORD-10006",
    productImage: OrderImg3,
    name: "Himalaya Treats",
    quantity: 4,
    weight: "0.5kg",
    price: "400",
    paymentMethod: "Card",
    customer: "Neha",
    orderTime: "21-04-25, 10AM",
    deliveryTime: "23-04-25, 11AM",
    shopName: "TailWaggers",
    status: "On Delivery",
    pickupLat: 37.769,
    pickupLng: -122.432,
    dropLat: 37.777,
    dropLng: -122.415,
  },
  {
    id: "ORD-10007",
    productImage: OrderImg1,
    name: "Me-O",
    quantity: 5,
    weight: "2kg",
    price: "850",
    paymentMethod: "Card",
    customer: "Karan",
    orderTime: "20-04-25, 3PM",
    deliveryTime: "22-04-25, 2PM",
    shopName: "Whisker World",
    status: "Delivered",
    pickupLat: 37.773,
    pickupLng: -122.423,
    dropLat: 37.782,
    dropLng: -122.408,
  },
  {
    id: "ORD-10008",
    productImage: OrderImg2,
    name: "Biscrok",
    quantity: 6,
    weight: "3kg",
    price: "950",
    paymentMethod: "UPI",
    customer: "Riya",
    orderTime: "19-04-25, 1PM",
    deliveryTime: "21-04-25, 9AM",
    shopName: "Furry Mart",
    status: "In Progress",
    pickupLat: 37.788,
    pickupLng: -122.419,
    dropLat: 37.796,
    dropLng: -122.407,
  },
  {
    id: "ORD-10009",
    productImage: OrderImg3,
    name: "JerHigh",
    quantity: 3,
    weight: "1.2kg",
    price: "700",
    paymentMethod: "Cash",
    customer: "Dev",
    orderTime: "18-04-25, 11AM",
    deliveryTime: "20-04-25, 5PM",
    shopName: "Paw Central",
    status: "Shipped",
    pickupLat: 37.761,
    pickupLng: -122.435,
    dropLat: 37.770,
    dropLng: -122.420,
  },
 
];


  const renderOrderDetailsModal = (order) => {
    const pickup = [order.pickupLat, order.pickupLng];
    const drop = [order.dropLat, order.dropLng];

    return (
      <div className="order-modal-overlay">
        <div className="order-modal">
          <div className="order-modal-header">
            <PageTitle title="Order Details" onBack={handleCloseModal} />
            <div className="order-status">
              <span className="status-label">Order Status:</span>
              <span className="status-value in-progress">In Progress</span>
              <button className="change-status-btn">Change Status</button>
            </div>
            <div className="modal-actions">
              <button className="cancel-order-btn" onClick={handleCloseModal}>
                ✕ Cancel Order
              </button>
            </div>
          </div>
          <div className="order-tracking-section-map">
            <div className="order-tracking-section">
              <div className="order-tracking-cnt">
                <div className="order-id">Order ID: {order.id}</div>
                {/* <div className="progress-tracker">
                  <div className="step completed">Order Booked</div>
                  <div className="step completed">Order Shipped</div>
                  <div className="step completed">On Delivery</div>
                  <div className="step completed">Order Delivered</div>
                </div> */}
                <div className="progress-tracker">
  <div className="step-wrapper">
    <div className={`step-circle ${order.status !== "Booked" ? "active" : ""}`}></div>
    <div className="step-label">
      <div>Order Booked</div>
      <div className="step-time">{order.orderTime}</div>
    </div>
  </div>
 
  <div className="step-wrapper">
    <div className={`step-circle ${["Shipped", "On Delivery", "Delivered"].includes(order.status) ? "active" : ""}`}></div>
    <div className="step-label">
      <div>Order Shipped</div>
      <div className="step-time">27-04-25, 10AM</div>
    </div>
  </div>


  <div className="step-wrapper">
    <div className={`step-circle ${["On Delivery", "Delivered"].includes(order.status) ? "active" : ""}`}></div>
    <div className="step-label">
      <div>On Delivery</div>
      <div className="step-time">27-04-25, 04PM</div>
    </div>
  </div>


  <div className="step-wrapper">
    <div className={`step-circle ${order.status === "Delivered" ? "active" : ""}`}></div>
    <div className="step-label">
      <div>Order Delivered</div>
    </div>
  </div>
</div>

              </div>

              <div className="order-modal-body">
                <div className="order-map">
                  <MapContainer
                    center={pickup}
                    zoom={15}
                    scrollWheelZoom={false}
                    style={{ height: "435px", borderRadius: "12px" }}
                  >
                    {/* Blue-themed tile layer */}
                    <TileLayer
                      url="https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png"
                      attribution="&copy; Stadia Maps"
                    />

                    <Polyline
                      positions={[pickup, drop]}
                      color="#840301"
                      weight={5}
                    />

                    <Marker
                      position={pickup}
                      icon={L.divIcon({
                        html: `<div style="color: red; font-size: 1.5rem;"><svg>${FaMapMarkerAlt(
                          {}
                        )}</svg></div>`,
                        className: "",
                        iconSize: [24, 24],
                      })}
                    >
                      <Popup>Pickup Point</Popup>
                    </Marker>

                    <Marker
                      position={drop}
                      icon={L.divIcon({
                        html: `<div style="color: green; font-size: 1.5rem;"><svg>${FaMapMarkerAlt(
                          {}
                        )}</svg></div>`,
                        className: "",
                        iconSize: [24, 24],
                      })}
                    >
                      <Popup>Drop Point</Popup>
                    </Marker>
                  </MapContainer>
                </div>
              </div>
            </div>
            <div className="order-info">
              <div className="order-info-row">
                <div>
                  <strong>Product Name:</strong>
                </div>
                <div>{order.name}</div>
              </div>
              <div className="order-info-row">
                <div>
                  <strong>Quantity:</strong>
                </div>
                <div> {order.quantity}</div>
              </div>
              <div className="order-info-row">
                  <div>
                  <strong>Amount:</strong>
                </div>
               
                <div>₹{order.price}</div>
              </div>
              <div className="order-info-row">
                <div>
                  <strong>Payment Method:</strong>
                </div>
                <div> {order.paymentMethod}</div>
              </div>
              <div className="order-info-row">
                <div>
                  <strong>Customer Name:</strong>
                </div>
                <div> {order.customer}</div>
              </div>
              <div className="order-info-row">
                <div>
                  <strong>Booked Time:</strong>
                </div>
                <div> {order.orderTime}</div>
              </div>
              <div className="order-info-row">
                <div>
                  <strong>Est Delivery Time:</strong>
                </div>
                <div> {order.deliveryTime}</div>
              </div>
              <div className="order-info-row">
                <div>
                  <strong>Shop Name:</strong>
                </div>
                <div> {order.shopName}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="container">
      <Sidebar />
      <div className="main">
        <Header />
        <div className="orders-page">
          <PageTitle title="Orders" onBack={handleBack} />
          <div className="Orders_container">
            {orders.map((order, index) => (
              <OrderCard
                key={index}
                {...order}
                onClick={() => handleCardClick(order)}
              />
            ))}
          </div>
        </div>
      </div>
      {selectedOrder && renderOrderDetailsModal(selectedOrder)}
    </div>
  );
};

export default OrdersScreen;
